<template>
  <div>
    <div v-if="ismark && !isnew">
      <comment-header
        :fathertitle="fathertitle"
        :childtitle="childtitle"
        :path="path"
      >
      </comment-header>
      <div
        class="
          page-header-index-wide page-header-wrapper-grid-content-main
          project
        "
      >
        <a-row :gutter="15">
          <a-col :span="5">
            <a-card
              :bordered="true"
              :style="{ minHeight: clientHeight + 'px' }"
            >
              <div class="FunctionButton">
                <h2>资源库(测试)</h2>
                <div :class="[card == 1 ? 'buttons' : 'buttons2']">
                  <a-button
                    title="添加资源库"
                    type="primary"
                    shape="circle"
                    icon="plus"
                    @click="addResource"
                  ></a-button>
                  <a-button
                    title="修改资源库名"
                    type="primary"
                    shape="circle"
                    icon="edit"
                    @click="updateResourceName"
                  ></a-button>
                  <a-button
                    title="删除资源库"
                    type="primary"
                    shape="circle"
                    icon="close"
                    @click="removeResource"
                  ></a-button>
                  <a-button
                    title="下载压缩包"
                    type="primary"
                    shape="circle"
                    icon="download"
                    @click="showdownloadModel"
                  ></a-button>
                </div>
              </div>
              <!-- <a-button-group>
                <a-button value="small" type="primary" @click="addResource">
                  <a-icon type="plus" />添加资源库</a-button
                >
                <a-button value="small" type="primary" @click="updateResourceName">
                  <a-icon type="edit" />修改资源库名</a-button
                >
                <a-button value="small" type="primary" @click="removeResource">
                  <a-icon type="close" />删除资源库</a-button
                >
              </a-button-group> -->
              <a-divider type="vertical" />
              <vue-scroll :ops="ops" style="width: 100%; height: 850px">
                <a-directory-tree
                  @select="treeSelect"
                  :showLine="false"
                  :load-data="loadResourceData"
                  :tree-data="projectListData"
                >
                </a-directory-tree>
              </vue-scroll>
            </a-card>
          </a-col>
          <a-col :span="19">
            <div ref="resourceRight">
              <a-card style="width: 100%" :bordered="false">
                <div slot="extra">
                  <a-row>
                    <a-col :span="5">
                      <uploader
                        v-if="startUpload"
                        :options="uploadOption"
                        :file-status-text="statusText"
                        :auto-start="true"
                        class="uploader-example"
                        ref="uploader"
                        @file-added="onFileAdded"
                        @file-success="onFileSuccess"
                        @file-error="onFileError"
                        @file-removed="fileRemoved"
                        @complete="uploadComplete"
                      >
                        <a-button
                          shape="circle"
                          icon="close"
                          style="float: right"
                          @click="uploadValidata"
                        ></a-button>
                        <br />
                        <br />
                        <uploader-unsupport></uploader-unsupport>
                        <uploader-drop>
                          <uploader-btn
                            :attrs="attrs"
                            style="background-color: #67c13b"
                            ><i
                              class="el-icon-upload"
                              style="margin-right: 5px"
                            ></i
                            >上传文件</uploader-btn
                          >
                          <i style="margin-right: 5px"
                            >{{ uploadFileCount }}/{{ fileCount }}</i
                          >
                          <!-- <uploader-btn :directory="true" style="background-color: #79bbff"
                          ><i class="el-icon-folder-add" style="margin-right: 5px"></i>上传文件夹</uploader-btn
                        > -->
                        </uploader-drop>
                        <uploader-list></uploader-list>
                      </uploader>

                      <a-button type="primary" @click="uploadValidata">
                        <a-icon type="upload" /> {{ uploadBtnTitle }}
                      </a-button>
                    </a-col>
                    <a-col :span="19">
                      <a-select
                        placeholder="请选择"
                        default-value="0"
                        v-model="queryParam.type"
                      >
                        <a-select-option value="0" key="0"
                          >-全部-</a-select-option
                        >
                        <a-select-option value="1" key="1"
                          >未标注</a-select-option
                        >
                        <a-select-option value="2" key="2"
                          >已标注</a-select-option
                        >
                      </a-select>
                      <a-input-search
                        style="margin-left: 16px"
                        placeholder="请输入文件名"
                        v-model="queryParam.name"
                        @search="search"
                      />
                      <!-- <a-button style="float:right" @click="changenew"> <a-icon type="retweet" /> 切换新版本 </a-button> -->
                    </a-col>
                  </a-row>
                  <a-divider style="margin-top: 8px" />
                  <a-row style="margin-top: 8px">
                    <a-button type="info" @click="checkAll">
                      {{ checkboxAllText }}
                    </a-button>
                    <a-button type="info" @click="checkDel"> 删除 </a-button>
                    <a-button type="info" @click="clearAll"> 清空 </a-button>
                    <a-button style="float: right" @click="showDrawer">
                      下载任务
                    </a-button>
                  </a-row>
                </div>
                <a-drawer
                  title="资源下载"
                  placement="right"
                  :closable="true"
                  :visible="showDrawerbtn"
                  :after-visible-change="afterVisibleChange"
                  @close="onClose"
                  :width="800"
                >
                  <CheckTable
                    :data="downloaddata"
                    :total="checktableTotal"
                    @changepage="changepage2"
                  />
                </a-drawer>
                <!-- <vue-scroll :ops="ops" style="width:100%;heiht:1200px"> -->
                <a-list
                  :grid="{ gutter: 16, column: 4 }"
                  :loading="listLoading"
                >
                  <a-checkbox-group
                    style="width: 100%"
                    @change="checkboxChange"
                    v-model="checkedValueList"
                  >
                    <a-list-item :key="index" v-for="(item, index) in fileData">
                      <a-card
                        :hoverable="true"
                        :class="[card == 1 ? 'card' : 'card2']"
                      >
                        <img
                          slot="cover"
                          :alt="item.fileName"
                          :width="item.width"
                          :height="item.height"
                          :src="
                            buildFilePath(item.imagePath, item.thumbFileName)
                          "
                          @click="
                            viewerItem2(
                              item.imagePath,
                            )
                          "
                        />
                        <template slot="actions" class="ant-card-actions">
                          <a-checkbox
                            :id="bindId(item.id)"
                            :value="item.id"
                          />
                          <a-icon
                            key="setting"
                            type="eye"
                            @click="
                              viewerItem2(
                                item.imagePath
                              )
                            "
                          />
                          <!-- <a-icon
                            type="highlight"
                            key="mark"
                            @click="gomark(item.fileId, item.imagePath, index)"
                          /> -->
                          <a-icon
                            key="close"
                            type="close"
                            @click="removeItem(item.id)"
                          />
                        </template>
                        <a-card-meta :title="item.fileName"> </a-card-meta>
                      </a-card>
                    </a-list-item>
                  </a-checkbox-group>
                </a-list>
                <!-- </vue-scroll> -->
                <div class="page">
                  <a-pagination
                    v-model="current"
                    :page-size-options="pageSizeOptions"
                    :total="paging.totalRecords"
                    :show-total="(total) => `共计 ${paging.totalRecords} 项`"
                    show-size-changer
                    :page-size="paging.pageSize"
                    @showSizeChange="onShowSizeChange"
                    @change="changePage"
                  >
                    <template slot="buildOptionText" slot-scope="props">
                      <span v-if="props.value !== '50'"
                        >{{ props.value }}条/页</span
                      >
                      <span v-if="props.value === '50'">全部</span>
                    </template>
                  </a-pagination>
                </div>
              </a-card>
            </div>
          </a-col>
        </a-row>
        <resource-edit-form
          ref="resourceEditForm"
          :title="title"
          :visible="visible"
          :loading="confirmLoading"
          :model="mdl"
          @cancel="handleCancel"
          @ok="handleOk"
        >
        </resource-edit-form>
        <image-preview
          ref="imagePreview"
          :title="imagePreview.title"
          :filePreviewShow="imagePreview.visible"
          @close="closePreview"
          :imgList="imagePreview.imageList"
          :size="imagePreview.size"
          :currentImg="imagePreview.currentImg"
        >
        </image-preview>

        <a-modal
          title="下载选项"
          :visible="showdownload"
          :confirm-loading="downloadLoading"
          @ok="clickDownloadOk"
          @cancel="clickDownloadCancel"
          okText="确定"
          cancelText="取消"
          :bodyStyle="{}"
        >
          <!-- <a-form-model
            :model="form"
            :label-col="{ span: 12 }"
            :wrapper-col="{ span: 12 }"
            ref="form"
          > -->
          <!-- <a-form-model-item label="资源类型" prop="resourcetype"> -->
          <div class="downloaditem">
            <span style="margin-right: 10px; margin-left: 100px">资源类型:</span
            ><a-checkbox-group
              v-model="form.resourcetype"
              :options="ResourceOptions"
            />
          </div>

          <!-- </a-form-model-item> -->
          <!-- <a-form-model-item label="是否压缩" prop="compress"> -->
          <div class="downloaditem">
            <span style="margin-right: 18px">是否压缩:</span>
            <a-radio-group v-model="form.compress" style="margin-right: -17px">
              <a-radio :value="1"> 是 </a-radio>
              <a-radio :value="2"> 否 </a-radio>
            </a-radio-group>
          </div>

          <!-- </a-form-model-item> -->
          <!-- <a-form-model-item label="是否清除FTP历史记录" prop="history"> -->
          <!-- <div class="downloaditem">
                <span style="marginRight:18px">是否清除FTP历史记录:</span>
                <a-radio-group v-model="form.history" style="marginRight:59px">
                  <a-radio :value="1"> 是 </a-radio>
                  <a-radio :value="2"> 否 </a-radio>
                </a-radio-group>
              </div> -->

          <!-- </a-form-model-item> -->
          <!-- </a-form-model> -->
        </a-modal>

        <!-- <file-uploader ref="fileUploader"  :visible="fileUploader.visible" :title="fileUploader.title" @close="closeFileUploader"> </file-uploader> -->
      </div>
    </div>
    <div v-if="!ismark">
      <Mark
        :imgurl="imgurl"
        :Colorindex="Colorindex"
        :id="imgId"
        :imgList="passOnfile"
        @changeismark="changemark"
        :filePathId="currentResourceId"
        :pageIndex="paging.pageIndex"
        :type="queryParam.type"
        :name="queryParam.name"
        :pageSize="paging.pageSize"
      />
    </div>
    <test-resource-new v-if="isnew" @returnback="changeOld" />
  </div>
</template>

<script>
import setrem from "../../utils/setRem";
import axios from "axios";
import RouteView from "./RouteView.vue";
import * as projectManagement from "@api/projectManage";
import * as labelFile from "@api/label_file";
import * as TestFile from "@api/test_file";
import { requestUrl } from "@utils/request_url";
import ResourceEditForm from "./ResourceEditForm";
import ImagePreview from "./ImagePreview";
import FileUploader from "./FileUploader";
import CommentHeader from "@components/header";
import Mark from "@views/TestLabel";
import TestResourceNew from "@components/TestResourceNew";
import CheckTable from "./CheckTable.vue";

const ResourceOptions = [
  {
    label: "图片文件",
    value: "picture",
  },
  {
    label: "标注文件",
    value: "mark",
  },
];
export default {
  components: {
    CheckTable,
    RouteView,
    ResourceEditForm,
    ImagePreview,
    FileUploader,
    CommentHeader,
    Mark,
    TestResourceNew,
  },
  // mixins: [baseMixin],
  data() {
    return {
      ResourceOptions,
      downloadLoading: false,
      showdownload: false,
      showDrawerbtn: false,
      imgurl: "",
      ismark: true,
      fathertitle: "测试管理",
      childtitle: "资源管理(测试)",
      path: "/train/project-list",
      visible: false,
      confirmLoading: false,
      mdl: null,
      title: "",
      fileList2: [],
      projectListData: [],
      // horizontal  inline
      mode: "inline",
      tmpStyle: "",
      NodeTreeItem: null,
      openKeys: [],
      selectedKeys: [],
      currentProjectId: 0,
      currentResourceId: 0,
      currentProject_ResourceId: 0,
      currentReourceName: "",
      preview: {},
      pageTitle: "",
      uploadHeaders: {},
      uploadData: {
        filePathId: 0,
      },
      showUploadList: true,
      paging: {
        pageSize: 16,
        totalRecords: 1,
        pageIndex: 1,
      },
      pageSizeOptions: ["8", "16", "24", "32", "40", "48", "96"],
      current: 1,
      fileData: [],
      queryParam: {
        name: "",
        type: "0",
      },
      listLoading: false,
      imagePreview: {
        title: "图片预览",
        visible: false,
        imageList: [],
        currentImg: "",
        size: {},
      },
      fileUploader: {
        title: "文件上传",
        visible: false,
      },
      clientHeight: 300,
      ops: {
        vuescroll: {},
        scrollPanel: {},
        rail: {
          keepShow: true,
        },
        bar: {
          hoverStyle: true,
          onlyShowBarOnScroll: true, // 是否只有滚动的时候才显示滚动条
          background: "#DC143C", // 滚动条颜色
          opacity: 1, // 滚动条透明度
          "overflow-x": "hidden",
        },
      },
      uploadOption: {
        target:
          requestUrl.replace("/api/", "") +
          "/zuul/api/train/rest/file/upload_test_resource",
        maxChunkRetries: 2,
        testChunks: false,
        fileParameterName: "file",
        chunkSize: 1024 * 1024 * 1024,
        simultaneousUploads: 3,
        query: {
          filePathId: 0,
        },
        headers: {
          // 'Authorization': token
        },
      },
      statusText: {
        success: "上传成功",
        error: "上传失败",
        uploading: "上传中",
        paused: "暂停中",
        waiting: "等待中",
      },
      attrs: {
        accept: [".jpg", ".png", ".json", ".zip"],
      },
      startUpload: false,
      uploadBtnTitle: "上传资源",
      file_total: 0, // 本次文件上传的总数
      errorfilelist: [], // 上传失败信息列表
      controllerErrorFileDialog: false,
      checkboxAllText: "全选",
      checkedValueList: [],
      checkAllStatus: false,
      uploadFileCount: 0,
      fileCount: 0,
      imgId: 0,
      Colorindex: 0,
      passOnfile: [],
      form: {
        resourcetype: ["picture", "mark"],
        compress: 2,
        history: 1,
      },
      downloadid: 0,
      downloaddata: [],
      getDownloadmsg: null,
      checktableTotal: 0,
      isnew: false,
      card: 1,
      zoomNum: null,
    };
  },
  created() {},
  computed: {
    uploadPath() {
      return requestUrl + "/train/rest/file/upload_resource";
    },
  },
  methods: {
    clickDownloadOk() {
      this.showdownload = false;
      console.log(this.form);
      projectManagement
        .createDownload({ pathId: this.downloadid })
        .then((r) => {
          projectManagement
            .getDownload({ pageIndex: 1, pageSize: 10 })
            .then((res) => {
              this.showDrawerbtn = true;
              this.downloaddata = res.data.list;
              this.getDownloadmsg = setInterval(() => {
                this.getdownmsg();
              }, 1000);
            });
        });
    },
    getdownmsg() {
      projectManagement
        .getDownload({ pageIndex: 1, pageSize: 10 })
        .then((res) => {
          this.downloaddata = res.data.list;
        });
    },
    clickDownloadCancel() {
      this.showdownload = false;
    },
    // changecompress(e){
    //   this.form.compress = e.target.value
    // },
    showdownloadModel() {
      if (this.currentResourceId != 0 || this.currentProject_ResourceId != 0) {
        const obj = {
          resourcetype: ["picture", "mark"],
          compress: 2,
          history: 1,
        };
        Object.assign(this.form, obj);
        this.showdownload = true;
        if (this.currentResourceId != 0) {
          this.downloadid = this.currentResourceId;
        } else {
          this.downloadid = this.currentProject_ResourceId;
        }
      } else {
        this.$message.warning("请选择资源节点");
      }
    },
    afterVisibleChange(val) {
      console.log("visible", val);
    },
    showDrawer() {
      projectManagement
        .getDownload({ pageIndex: 1, pageSize: 10 })
        .then((res) => {
          this.showDrawerbtn = true;
          this.downloaddata = res.data.list;
          this.checktableTotal = res.data.totalRecords;
          if (this.getDownloadmsg == null) {
            this.getDownloadmsg2 = setInterval(() => {
              projectManagement
                .getDownload({ pageIndex: 1, pageSize: 10 })
                .then((res) => {
                  this.downloaddata = res.data.list;
                  this.checktableTotal = res.data.totalRecords;
                });
            }, 1000);
          }
        });
    },
    changepage2(currentpage) {
      clearInterval(this.getDownloadmsg);
      clearInterval(this.getDownloadmsg2);
      projectManagement
        .getDownload({ pageIndex: currentpage, pageSize: 10 })
        .then((res) => {
          this.downloaddata = res.data.list;
          this.getDownloadmsg = setInterval(() => {
            projectManagement
              .getDownload({ pageIndex: currentpage, pageSize: 10 })
              .then((res) => {
                this.downloaddata = res.data.list;
              });
          }, 1000);
        });
    },
    onClose() {
      this.showDrawerbtn = false;
      clearInterval(this.getDownloadmsg);
      clearInterval(this.getDownloadmsg2);
    },
    changemark(value) {
      this.ismark = value;
    },
    gomark(id, path, index) {
      this.Colorindex = index;
      this.imgId = id;
      this.ismark = false;
      this.imgurl = requestUrl + path;
      this.deliverfile();
    },
    bindId(id) {
      return "checkbox_" + id;
    },
    checkboxChange(checkedValues) {
      console.log("checked = ", checkedValues);
    },
    checkAll() {
      if (!this.checkAllStatus) {
        this.checkAllStatus = true;
        var ids = [];
        this.fileData.forEach((item, index, arr) => {
          ids.push(item.id);
        });
        this.checkedValueList = ids;
        this.checkboxAllText = "取消全选";
      } else {
        this.checkAllStatus = false;
        this.checkedValueList = [];
        this.checkboxAllText = "全选";
      }
    },
    uploadComplete() {},
    onShowSizeChange(current, pageSize) {
      this.paging.pageSize = pageSize;
      this.loadData();
    },
    changePage(page, pageSize) {
      this.paging.pageIndex = page;
      this.loadData();
    },
    buildFilePath(fileName, thumbFileName) {
      // var file = ''
      // if(thumbFileName != null){
      //   file = thumbFileName
      // }else {
      //   file = fileName
      // }
      var file = "";
      file = fileName.replace(/#/g, "%23");
      // file = fileName;
      var image = new Image();
      image.src = requestUrl + file;
      return requestUrl + file;
    },
    setImageH_W(fileName) {
      const self = this;
      var imageW;
      var imageH;
      var image = new Image();
      image.src = requestUrl + fileName;
      image.onload(() => {
        imageW = image.width;
        imageH = image.height;
        self.imageW = imageW;
      });
    },
    setImageW(fileName) {},
    loadProjectData() {
      const self = this;
     
      projectManagement.getAllProject().then((res) => {
        self.projectListData = [];
        if (res.data !== undefined && res.data != null && res.data.length > 0) {
          for (let index = 0; index < res.data.length; index++) {
            const element = res.data[index];
            self.projectListData.push({
              title: element.name,
              key: "p-" + element.id,
              value: "p-" + element.id,
            });
          }
          self.projectListData.sort((a, b) => a.title.localeCompare(b.title, 'zh-Hans-CN', {sensitivity: 'accent'}))
        }
      });
    },
    async loadResourceData(treeNode) {
   
      const treeNodeValue = treeNode.value;
      if (!treeNode.dataRef.children) treeNode.dataRef.children = [];

      var treeNodeSplitValues = treeNodeValue.split("-");
      console.log(treeNodeSplitValues);
      if (treeNodeSplitValues[0] === "p") {
        const datas = await this.loadLabelResourceList(
          parseInt(treeNodeSplitValues[1])
        );
        const treeDatas = this.buildTreeData(datas);
        treeDatas.sort((a, b) => a.title.localeCompare(b.title, 'zh-Hans-CN', {sensitivity: 'accent'}))
        console.log(treeDatas);
        treeNode.dataRef.children = treeDatas;
        this.projectListData = [...this.projectListData];
      }
       else if (treeNodeSplitValues[0] === "pr") {
        // 二级目录这里的接口需要修改
        const datas = await this.loadLabelResourceList2(treeNodeSplitValues[1]);
        const treeDatas = this.buildTreeData2(datas);
        treeDatas.sort((a, b) => a.title.localeCompare(b.title, 'zh-Hans-CN', {sensitivity: 'accent'}))
        treeNode.dataRef.children = treeDatas;
        
        this.projectListData = [...this.projectListData];
      }
    },

    loadLabelResourceList(param) {
      return TestFile.getTestResourceList(param).then((res) => {
        return res.data;
      });
    },

    buildTreeData(datas) {
      console.log(datas);
      if (!datas) {
        return;
      } else {
        return datas.map((data) => {
          return {
            title: data.name,
            key: "pr-" + data.id,
            value: "pr-" + data.id,
          };
        });
      }
    },
    buildTreeData2(datas) {
      return datas.map((data) => {
        return {
          title: data.name,
          key: "r-" + data.id,
          value: "r-" + data.id,
        };
      });
    },
    loadLabelResourceList2(param) {
      // 获取三级目录的接口需要修改
      return labelFile.getLabelResourceList2(param).then((res) => {
        return res.data;
      });
    },
    treeSelect(keys, event) {
      console.log(keys);
      const splittKeys = keys[0].split("-");
      if (splittKeys[0] === "p") {
        this.currentProjectId = parseInt(splittKeys[1]);
        this.currentResourceId = 0;
        this.currentProject_ResourceId = 0;
        this.currentReourceName = "";
      } else if (splittKeys[0] === "pr") {
        this.currentResourceId = parseInt(splittKeys[1]);
        this.currentProjectId = 0;
        this.currentProject_ResourceId = 0;
        this.currentReourceName = event.node.title;
        this.loadData();
      } else {
        this.currentResourceId = 0;
        this.currentProjectId = 0;
        this.currentProject_ResourceId = parseInt(splittKeys[1]);
        this.currentReourceName = event.node.title;
        this.loadData();
      }
    },
    addResource() {
      // 判断条件需要改
      if (this.currentProjectId === 0) {
        this.$message.warning("请选择项目节点");
      } else {
        this.visible = true;
        this.title = "新增资源库";
        this.mdl = {};
      }
    },
    updateResourceName() {
      // 判断条件需要改
      if (this.currentResourceId === 0) {
        this.$message.warning("请选择资源节点");
      } else {
        this.title = "更新资源库";
        this.mdl = {
          name: this.currentReourceName,
        };
        this.visible = true;
      }
    },
    removeResource() {
      const self = this;

      if (
        this.currentResourceId === 0 &&
        this.currentProject_ResourceId === 0
      ) {
        this.$message.warning("请选择资源节点");
      } else {
        var removeId =
          this.currentResourceId == 0
            ? this.currentProject_ResourceId
            : this.currentResourceId;
        this.$confirm({
          title: `你想要删除此资源库吗?`,
          content: `当你点击确认按钮时, 自动更新列表`,
          okText: "确认",
          cancelText: "取消",
          onOk() {
            return new Promise((resolve, reject) => {
              setTimeout(() => {
                resolve();
              }, 500);
            })
              .then((res) => {
                TestFile.removeTestResource({ id: removeId }).then((r) => {
                  var flag = false;
                  for (
                    let index = 0;
                    index < self.projectListData.length;
                    index++
                  ) {
                    const element = self.projectListData[index];
                    if (
                      element.children !== undefined &&
                      element.children.length > 0
                    ) {
                      for (
                        let index2 = 0;
                        index2 < element.children.length;
                        index2++
                      ) {
                        const element2 = element.children[index2];
                        if (
                          element2.key ===
                          "pr-" + self.currentResourceId
                          // element2.key ===
                          //   "pr-" + self.currentProject_ResourceId
                        ) {
                          element.children.splice(index2, 1);
                          self.currentResourceId = 0;
                          self.currentProject_ResourceId = 0;
                          self.currentReourceName = "";
                          flag = true;
                          self.projectListData = [...self.projectListData];
                          break;
                        }
                      }
                      if (flag) {
                        break;
                      }
                    }
                  }
                  self.fileData = [];
                  self.paging.pageIndex = 1;
                  self.paging.totalRecords = 1;
                  self.currentResourceId = null;
                });
              })
              .catch(() => console.log("小猪，出错啦，休息会吧!"));
          },
          autoFocusButton: null,
        });
      }
    },
    handleOk() {
      const form = this.$refs.resourceEditForm.form;
      const self = this;
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log("values", values);
          new Promise((resolve, reject) => {
            setTimeout(() => {
              resolve();
            }, 500);
          }).then((res) => {
            if (this.title == "新增资源库") {
              if (self.currentProjectId > 0) {
                // 新增
                TestFile.addTestResource({
                  ...values,
                  projectId: this.currentProjectId,
                }).then((r) => {
                  self.visible = false;
                  self.confirmLoading = false;
                  form.resetFields();
                  console.log(r);
                  for (
                    let index = 0;
                    index < self.projectListData.length;
                    index++
                  ) {
                    const element = self.projectListData[index];
                    if (element.key === "p-" + self.currentProjectId) {
                      if (element.children === undefined) {
                        element.children = [];
                      }

                      var resourceRoot = {};
                      if (
                        r.data.children == null ||
                        r.data.children.length === 0
                      ) {
                        resourceRoot = {
                          title: r.data.name,
                          key: "pr-" + r.data.id,
                          value: "pr-" + r.data.id,
                        };
                      } else {
                        resourceRoot = {
                          title: r.data.name,
                          key: "pr-" + r.data.id,
                          value: "pr-" + r.data.id,
                        };
                        resourceRoot.children = [];
                        r.data.children.forEach((e) => {
                          resourceRoot.children.push({
                            title: e.name,
                            key: "pr-" + e.id,
                            value: "pr-" + e.id,
                          });
                        });
                      }

                      element.children.push(resourceRoot);
                      self.projectListData = [...self.projectListData];
                      break;
                    }
                  }
                  this.$message.success("新增成功");
                });
              }
              if(self.currentProject_ResourceId > 0) {
                //添加三级目录需要改接口
              // labelFile
              //   .addLabelResourceChild({
              //     ...values,
              //     pid: this.currentProject_ResourceId,
              //   }).then((r) => {
              //     self.visible = false;
              //     self.confirmLoading = false;
              //     form.resetFields();
              //     console.log(r);
              //     for(let index = 0;index < self.projectListData.length; index++){
              //       console.log(self.projectListData[index].children);
              //       if(self.projectListData[index].children){
              //       for(let i = 0; i< self.projectListData[index].children.length; i++){
              //         var element = {}
              //         element = self.projectListData[index].children[i]
              //         console.log(element);
              //         if(element.key === "pr-" + self.currentProject_ResourceId){
              //           if (element.children === undefined) {
              //           element.children = [];
              //         }
              //         var resourceRoot = {};
              //         if (
              //           r.data.children == null ||
              //           r.data.children.length === 0
              //         ) {
              //           resourceRoot = {
              //             title: values.name,
              //             key: "r-" + r.data.id,
              //             value: "r-" + r.data.id,
              //           };
              //         } else {
              //           resourceRoot = {
              //             title: values.name,
              //             key: "pr-" + r.data.id,
              //             value: "pr-" + r.data.id,
              //           };
              //           resourceRoot.children = [];
              //           r.data.children.forEach((e) => {
              //             resourceRoot.children.push({
              //               title: values.name,
              //               key: "r-" + e.id,
              //               value: "r-" + e.id,
              //             });
              //           });
              //         }
              //         element.children.push(resourceRoot);
              //         self.projectListData = [...self.projectListData];
              //         break;
              //         }
              //       }
              //       }
              //     }
              //     this.$message.success("新增成功");
              //     console.log(self.projectListData);
              //   })
            }
            }

            if (this.title == "更新资源库") {
              if (self.currentResourceId > 0) {
                TestFile.updateTestResource({
                  ...values,
                  id: self.currentResourceId,
                }).then((r) => {
                  self.visible = false;
                  self.confirmLoading = false;
                  form.resetFields();
                  var flag = false;

                  for (
                    let index = 0;
                    index < self.projectListData.length;
                    index++
                  ) {
                    const element = self.projectListData[index];
                    if (
                      element.children !== undefined &&
                      element.children.length > 0
                    ) {
                      for (
                        let index2 = 0;
                        index2 < element.children.length;
                        index2++
                      ) {
                        const element2 = element.children[index2];
                        if (
                          element2.key === "r-" + self.currentResourceId ||
                          element2.key === "pr-" + self.currentResourceId
                        ) {
                          element2.title = values.name;
                          self.currentReourceName = values.name;
                          flag = true;
                          break;
                        }
                      }
                      // if (flag) {
                      //   self.projectListData = [...self.projectListData]
                      //   break
                      // }
                    }
                  }
                  this.$message.success("更新成功");
                });
              }
              if(self.currentProject_ResourceId >0){
                //更新二级资源库
              // labelFile
              //   .updateLabelResourceName({
              //     ...values,
              //     id: self.currentProject_ResourceId,
              //   }).then((res) => {
              //     for(let index = 0;index< self.projectListData.length;index++){
                    
              //       if(self.projectListData[index].children){
              //         for(let i = 0;i< self.projectListData[index].children.length;i++){
              //           if(self.projectListData[index].children[i].key == 'pr-' + self.currentProject_ResourceId){
              //             self.projectListData[index].children[i].title = values.name
              //           }
              //       }
              //       }
                    
              //     }
              //     self.projectListData = [...self.projectListData]
              //     self.visible = false;
              //     self.confirmLoading = false;
              //     self.$message.success("更新成功");
              //   })
            }
            }
          });
        } else {
          this.confirmLoading = false;
        }
      });
    },
    modifyTreeData() {},
    handleCancel() {
      if (
        this.$refs !== undefined ||
        this.$refs.resourceEditForm.form !== undefined
      ) {
        this.$refs.resourceEditForm.form.resetFields();
      }
      this.visible = false;
    },
    uploadValidata() {
      const self = this;
      if (this.startUpload) {
        if (this.uploadFileCount < this.fileCount) {
          // 未上传完 强制关闭
          this.$confirm({
            title: `资源还未上传完，您想强制关闭上传组件吗？`,
            content: `当你点击确认按钮时, 强制停止上传`,
            onOk() {
              return new Promise((resolve, reject) => {
                setTimeout(() => {
                  resolve();
                }, 500);
              })
                .then((res) => {
                  self.cancelUpload();
                  self.loadData();
                  self.startUpload = false;
                  self.uploadBtnTitle = "上传资源";
                })
                .catch((err) => console.log(err));
            },
            autoFocusButton: null,
          });
        } else {
          this.loadData();
          this.startUpload = false;
          this.uploadBtnTitle = "上传资源";
        }
      } else {
        if (this.currentResourceId === 0) {
          this.$message.warning("请选择资源节点");
          return false;
        } else {
          console.log(this.currentResourceId);
          this.uploadOption.query.filePathId = this.currentResourceId;
          this.startUpload = true;
          // this.uploadBtnTitle = "关闭上传";
          this.fileCount = 0;
          this.uploadFileCount = 0;
        }
      }
    },
    search() {
      // 判断条件需要改
      if (this.currentResourceId === 0) {
        this.$message.warning("请选择资源节点");
      } else {
        this.loadData();
      }
    },
    deliverfile() {
      const self = this;
      // 图片列表修改
      labelFile
        .getLabelFilePage({
          pageIndex: self.paging.pageIndex,
          pageSize: self.paging.pageSize,
          name: self.queryParam.name,
          type: self.queryParam.type,
          filePathId: self.currentResourceId,
        })
        .then((res) => {
          this.passOnfile = res.data.list;
          console.log(this.passOnfile);
        });
    },
    loadData() {
      const self = this;
      self.listLoading = true;
      self.fileData = [];
      TestFile.getTestPageFile({
        pageIndex: self.paging.pageIndex,
        pageSize: self.paging.pageSize,
        name: self.queryParam.name,
        type: self.queryParam.type,
        filePathId: self.currentResourceId, // 这里的id要改
      }).then((res) => {
        self.checkedValueList = [];
        self.checkAllStatus = false;
        self.checkboxAllText = "全选";

        if (
          res.data != undefined &&
          res.data != null &&
          res.data.list.length > 0
        ) {
          self.paging.totalRecords = res.data.totalRecords;
          if (this.zoomNum <= 125) {
            for (let index = 0; index < res.data.list.length; index++) {
              const element = res.data.list[index];

              var w = element.width;
              var h = element.height;
              element.realHeight = h;
              element.realWidth = w;
              if (w > h) {
                if (w > 215) {
                  // var scale = w / 268
                  // element.imageWidth = 268 + 'px'
                  // element.imageHeight = h / scale + 'px'
                  const scale = w / h;
                  if (215 / scale > 200) {
                    element.height = 200 + "px";
                    element.width = 200 * scale + "px";
                  } else {
                    element.height = 215 / scale + "px";
                    element.width = 215 + "px";
                  }
                }
              } else {
                if (h > 200) {
                  const scale = h / 200;
                  element.height = 200 + "px";
                  element.width = w / scale + "px";
                }
              }

              self.fileData.push(element);
            }
          } else {
            for (let index = 0; index < res.data.list.length; index++) {
              const element = res.data.list[index];

              var w1 = element.width;
              var h1 = element.height;
              element.realHeight = h1;
              element.realWidth = w1;
              if (w1 > h1) {
                if (w1 > 180) {
                  // var scale = w / 268
                  // element.imageWidth = 268 + 'px'
                  // element.imageHeight = h / scale + 'px'
                  const scale = w1 / h1;
                  if (180 / scale > 150) {
                    element.height = 150 + "px";
                    element.width = 150 * scale + "px";
                  } else {
                    element.height = 180 / scale + "px";
                    element.width = 180 + "px";
                  }
                }
              } else {
                if (h1 > 150) {
                  const scale = h1 / 150;
                  element.height = 150 + "px";
                  element.width = w1 / scale + "px";
                }
              }

              self.fileData.push(element);
            }
          }
          console.log(self.fileData);
        } else {
          self.paging.totalRecords = 0;
          self.paging.pageIndex = 1;
        }
        self.listLoading = false;
      });
    },
    requestData(self) {},
    // signFlag(filePathId) {
    //   return new Promise((resolve, reject) => {
    //     labelFile
    //       .showSign(filePathId)
    //       .then((res) => {
    //         resolve(res)
    //         console.log(res)
    //       })
    //       .catch((err) => {
    //         reject(err)
    //       })
    //   })
    // },
    viewerItem(id, filePath, height, width) {
      this.imagePreview.imageList = [];
      this.imagePreview.imageList.push(requestUrl + filePath);
      this.imagePreview.visible = true;
      this.imagePreview.size.height = height;
      this.imagePreview.size.width = width;
    },
    viewerItem2(filePath){
      this.$hevueImgPreview(requestUrl+filePath);
    },
    removeItem(id) {
      const self = this;
      this.$confirm({
        title: `你想要删除此资源吗?`,
        content: `当你点击确认按钮时, 自动更新列表`,
        okText: "确定",
        cancelText: "取消",
        onOk() {
          return new Promise((resolve, reject) => {
            setTimeout(() => {
              resolve();
            }, 500);
          })
            .then((res) => {
              TestFile.removeTestFile({ id: id }).then((r) => {
                self.paging.pageIndex = 1;
                self.loadData();
              });
            })
            .catch(() => console.log("小猪，出错啦，休息会吧!"));
        },
        autoFocusButton: null,
      });
    },
    pageChange() {
      this.loadData();
    },
    closePreview() {
      this.imagePreview.visible = false;
    },
    //
    onFileAdded(file) {
      const file_type = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension =
        file_type === "png" ||
        file_type === "jpg" ||
        file_type === "jpeg" ||
        file_type === "zip" ||
        file_type == "json";
      if (!extension) {
        const obj = {
          rootname: "无",
          name: file.name,
          errorinfo: "文件不是 " + this.uploadType + " 格式",
        };
        const arr = file.relativePath.split("/");
        if (arr.length > 1) {
          obj["rootname"] = arr[0];
        }
        this.errorfilelist.push(obj);
        file.ignored = true;
      } else {
        file.resume();
      }
      this.$nextTick(() => {
        this.fileCount = this.$refs["uploader"].files.length;
      });
      // if (this.errorfilelist.length !== 0) {
      //   this.controllerErrorFileDialog = true
      // }
    },

    // 每个文件传输给后端之后，返回的信息
    onFileSuccess(rootFile, file, response, chunk) {
      const res = JSON.parse(response);
      if (res.code !== 10002) {
        const obj = {
          rootname: "无",
          name: file.name,
          errorinfo: res.message,
        };
        if (rootFile.isFolder === true) {
          obj["rootname"] = rootFile.name;
        }
        this.errorfilelist.push(obj);
        this.controllerErrorFileDialog = true;
      } else {
        this.$nextTick(() => {
          this.uploadFileCount++;
        });
      }
    },
    // 上传错误触发，文件还未传输到后端
    onFileError(rootFile, file, response, chunk) {
      const obj = {
        rootname: "无",
        name: file.name,
        errorinfo: "文件上传失败",
      };
      if (rootFile.isFolder === true) {
        obj["rootname"] = rootFile.name;
      }
      this.errorfilelist.push(obj);
      this.controllerErrorFileDialog = true;
    },
    // 移除文件
    fileRemoved(file) {
      this.$nextTick(() => {
        this.fileCount = this.$refs["uploader"].files.length;
      });
    },
    // 点击开始上传按钮
    // submitUpload() {
    //   this.$nextTick(() => {
    //     for (var i = 0; i < this.$refs['uploader'].files.length; i++) {
    //       this.$refs['uploader'].files[i].resume()
    //     }
    //   })
    // },
    // 关闭错误文件提示框口，知道上传对话框被关闭时才会被清空
    closeErrorDialog() {
      this.errorDialog = false;
    },
    // 上传弹框关闭
    handelClose() {
      this.clearcache();
      this.thirdDialog = false;
    },
    // 清除缓存
    clearcache() {
      this.errorfilelist = [];
      this.controllerErrorFileDialog = false;
      this.$refs.uploader.uploader.cancel();
    },
    // 取消上传
    cancelUpload() {
      this.thirdDialog = false;
      this.clearcache();
    },

    checkDel() {
      if (this.checkedValueList.length == 0) {
        this.$message.warning("请选择需要删除的资源");
      } else {
        const self = this;
        this.$confirm({
          title: `你想要删除此选择的资源吗?`,
          content: `当你点击确认按钮时, 自动更新列表`,
          okText: "确定",
          cancelText: "取消",
          onOk() {
            return new Promise((resolve, reject) => {
              setTimeout(() => {
                resolve();
              }, 500);
            })
              .then((res) => {
                var ids = [];
                for (var i = 0; i < self.checkedValueList.length; i++) {
                  ids.push({
                    id: self.checkedValueList[i],
                  });
                }
                TestFile.removeTestFiles(ids).then((r) => {
                  self.paging.pageIndex = 1;
                  self.loadData();
                });
              })
              .catch(() => console.log("小猪，出错啦，休息会吧!"));
          },
          autoFocusButton: null,
        });
      }
    },

    clearAll() {
      if (this.currentResourceId == 0) {
        this.$message.warning("请选择需要删除的资源节点");
      } else {
        const self = this;
        this.$confirm({
          title: `你想要清除所有的资源列表吗?`,
          content: `当你点击确认按钮时, 自动更新列表`,
          okText: "确定",
          cancelText: "取消",
          onOk() {
            return new Promise((resolve, reject) => {
              setTimeout(() => {
                resolve();
              }, 500);
            })
              .then((res) => {
                TestFile.clearAllTestFile({
                  id: self.currentResourceId,
                }).then((r) => {
                  self.paging.pageIndex = 1;
                  self.loadData();
                });
              })
              .catch(() => console.log("小猪，出错啦，休息会吧!"));
          },
          autoFocusButton: null,
        });
      }
    },
    changenew() {
      this.isnew = true;
    },
    changeOld(value) {
      this.isnew = !value;
    },
    detectZoom() {
      var ratio = 0,
        screen = window.screen,
        ua = navigator.userAgent.toLowerCase();

      if (window.devicePixelRatio !== undefined) {
        ratio = window.devicePixelRatio;
      } else if (ua.indexOf("msie")) {
        if (screen.deviceXDPI && screen.logicalXDPI) {
          ratio = screen.deviceXDPI / screen.logicalXDPI;
        }
      } else if (
        window.outerWidth !== undefined &&
        window.innerWidth !== undefined
      ) {
        ratio = window.outerWidth / window.innerWidth;
      }

      if (ratio) {
        ratio = Math.round(ratio * 100);
      }

      return ratio;
    },
  },
  watch: {},
  mounted() {
    this.$nextTick(() => {
      this.clientHeight = this.$refs.resourceRight.clientHeight;
      this.loadProjectData();
    });
    // setrem()
    // window.onresize = function() {
    //   setrem
    // }
    const that = this;
    // 当屏幕缩放大于125时使图片card自适应
    that.zoomNum = that.detectZoom();
    if (that.zoomNum > 125) {
      that.card = 2;
    } else {
      that.card = 1;
    }
    // 屏幕缩放发生变化时判断，然后自适应
    window.onresize = function () {
      that.zoomNum = that.detectZoom();
      if (that.zoomNum > 125) {
        that.card = 2;
      } else {
        that.card = 1;
      }
      // 防止一开始加载页面时出现的等待logo
      if (that.currentResourceId != 0) {
        that.loadData();
      }
    };
  },
  beforeDestroy() {
    clearInterval(this.getDownloadmsg);
    clearInterval(this.getDownloadmsg2);
    this.getDownloadmsg = null;
  },
};
</script>

<style lang="less" scoped>
.downloaditem {
  display: block;
  text-align: center;
  line-height: 32px;
}
.FunctionButton {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .buttons {
    margin-top: 10px;
    width: 230px;
    display: flex;
    justify-content: space-around;
  }
  .buttons2 {
    margin-top: 10px;
    width: 200px;
    display: flex;
    justify-content: space-around;
  }
}
.uploader-example {
  background-color: white;
  width: 600px;
  padding: 15px;
  margin: 0 auto 0;
  font-size: 14px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.9);
  z-index: 9999;
  top: 300px;
  left: 55%;
  position: fixed;
}
.uploader-example .uploader-btn {
  margin-right: 8px;
  color: #ffffff;
  border: #ffffff;
}
/deep/ .uploader-example .uploader-list {
  max-height: 300px;
  overflow: auto;
  overflow-x: hidden;
  overflow-y: auto;
  .uploader-file[status="uploading"] > .uploader-file-info {
    > .uploader-file-status > span > i {
      visibility: hidden;
    }
    > .uploader-file-status > span > em {
      visibility: hidden;
    }
  }
}
.card {
  // width: 270px;
  width: 220px;
  height: 300px;
}
.card2 {
  width: 180px;
  height: 300px;
}
.project /deep/ .ant-input-affix-wrapper {
  width: 60%;
}
.project /deep/ .ant-card-body {
  padding: 16px 8px;
}
.page {
  text-align: right;
}
.ant-row-flex {
  width: 1000px;
}

* {
  margin: 0;
  // padding: 0;
  list-style-type: none;
}

// 滚动条位置
/deep/.__bar-is-vertical {
  right: -1px !important;
}
// 隐藏横向滚动条
/deep/.__bar-is-horizontal {
  display: none !important;
}
.account-settings-info-main {
  width: 100%;
  display: flex;
  height: 100%;
  overflow: auto;

  &.mobile {
    display: block;

    .account-settings-info-left {
      border-right: unset;
      border-bottom: 1px solid #e8e8e8;
      width: 100%;
      height: 50px;
      overflow-x: auto;
      overflow-y: scroll;
    }
    .account-settings-info-right {
      padding: 20px 40px;
    }
  }

  .account-settings-info-left {
    border-right: 1px solid #e8e8e8;
    width: 224px;
  }

  .account-settings-info-right {
    flex: 1 1;
    padding: 8px 40px;

    .account-settings-info-title {
      color: rgba(0, 0, 0, 0.85);
      font-size: 20px;
      font-weight: 500;
      line-height: 28px;
      margin-bottom: 12px;
    }
    .account-settings-info-view {
      padding-top: 12px;
    }
  }
}
/deep/ .ant-card-extra {
  float: right;
  margin-left: 0px;
  padding: 16px 0;
  color: rgba(0, 0, 0, 0.65);
  font-weight: normal;
  font-size: 14px;
  width: 100%;
}
</style>

<style >
.ant-card-actions {
  bottom: 0px;
  position: absolute;
  margin: 0;
  padding: 0;
  list-style: none;
  background: #fafafa;
  border-top: 1px solid #e8e8e8;
  zoom: 1;
  width: 100%;
}
.ant-card-cover {
  height: 200px;
  width: auto;
  justify-items: center;
  align-items: center;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.ant-card-cover img {
  border-radius: 2px 2px 0 0;
  width: auto;
  margin: 0 auto;
}

.ant-card-meta-title {
  overflow: hidden;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 10;
  font-size: 8px;
  /* white-space: nowrap; */
  text-overflow: ellipsis;
  text-align: center;
}

/* .ant-card-extra {
  float: right;
  margin-left: 0px;
  padding: 16px 0;
  color: rgba(0, 0, 0, 0.65);
  font-weight: normal;
  font-size: 14px;
} */
</style>
